import { authFetch } from './auth';

/**
 * Opens a /resources document: asks the backend for a time-limited download
 * URL and follows it in a new tab. The one download path for resources —
 * the Resources page and the sources panel in chat both use it, so an item
 * opens the same way everywhere. Failures are reported to the user here and
 * never thrown.
 *
 * @param {string} resourceId
 * @param {string} resourceTitle - suggested file name
 */
export const downloadResource = async (resourceId, resourceTitle) => {
  try {
    const response = await authFetch(`/resources/${resourceId}/download`);

    if (!response.ok) {
      throw new Error('Failed to get download URL');
    }

    const { url } = await response.json();

    // Trigger download
    const link = document.createElement('a');
    link.href = url;
    link.download = resourceTitle || 'resource';
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (err) {
    console.error('Error downloading resource:', err);
    alert('Kunne ikke laste ned ressursen. Vennligst prøv igjen.');
  }
};
